export default [
	"All apps",
	"All games",
	"Art & Design",
	"Auto & Vehicles",
	"Beauty",
	"Books & Reference",
	"Business",
	"Comics",
	"Communication",
	"Dating",
	"Education",
	"Entertainment",
	"Events",
	"Finance",
	"Food & Drink",
	"Health & Fitness",
	"House & Home",
	"Lifestyle",
	"Maps & Navigation",
	"Medical",
	"Music & Audio",
	"News & Magazines",
	"Parenting",
	"Personalization",
	"Photography",
	"Productivity",
	"Shopping",
	"Social",
	"Sports",
	"Tools",
	"Travel & Local",
	"Video Players & Editors",
	"Weather",
	"Libraries & Demo",
	"Arcade",
	"Puzzle",
	"Cards",
	"Casual",
	"Racing",
	"Sport Games",
	"Action",
	"Adventure",
	"Board",
	"Casino",
	"Educational",
	"Music Games",
	"Role Playing",
	"Simulation",
	"Strategy",
	"Trivia",
	"Word Games",
	"Family All Ages",
	"Family Action",
	"Family Brain Games",
	"Family Create",
	"Family Education",
	"Family Music & Video",
	"Family Pretend Play",
]